import React from 'react';
import { Modal, Box, Typography, Button } from '@mui/material';
import { styled } from '@mui/system';

const ModalUpdateConsistency = ({ open, onClose, onUpdate }) => {

    const CancelButton = styled(Button)({
        backgroundColor: '#DE3436',
        color: 'white',
        '&:hover': {
          backgroundColor: '#DC1F21', 
        },
      });
      
      const ConfirmButton = styled(Button)({
        backgroundColor: '#469F3F',
        color: 'white',
        '&:hover': {
          backgroundColor: '#32932B', 
        },
      });

      
  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: {
            xs: "90vw",
            sm: 400,
          },
          maxHeight: "90vh",
          bgcolor: "background.paper",
          border: "0px solid #000",
          boxShadow: 24,
          p: {
            xs: 2,
            sm: 4,
          },
          overflowY: "auto",
          borderRadius: 2,
        }}
      >
        <Typography sx={{ mt: 2, fontSize: "18px", color: "#383838"}}>
            Anda yakin akan mengupdate semua yang berbeda dari nilai ERRI menjadi sama dengan nilai yang ada di produk dan store master SIVINA?
        </Typography>
        <Box mt={4} display="flex" justifyContent="flex-end">
          <CancelButton onClick={onClose} style={{ marginRight: '8px' }}>
            Tidak
          </CancelButton>
          <ConfirmButton onClick={onUpdate}>
            Ya
          </ConfirmButton>
        </Box>
      </Box>
    </Modal>
  );
};

export default ModalUpdateConsistency;
